"use client";

import * as React from "react";
import {AopsThemeProvider} from "@repo/ui/mantine";
import {Provider as JotaiProvider} from "jotai";

export function Providers({children}: {children: React.ReactNode}) {
	return (
		<JotaiProvider>
			<AopsThemeProvider>{children}</AopsThemeProvider>
		</JotaiProvider>
	);
}
